<template>
    <div class="article_modal_container">
        <div class="article_modal">
            <!-- <div class="x_btn" @click="closeModal">ⓧ</div> -->

            <div style="font-size:28px; font-weight:700; text-align:center; margin-top:30px;">
                이것은 잘못된 근거입니다.<br>채택하면 안 됩니다!<br>
                <div style="font-size:18px; font-weight:400; margin:30px; word-break:keep-all;">
                    글쓴이와 출처, 설명/논리가 타당하더라도 오래된 정보일 경우와<br>설명/논리 근거가 서로 다른 주장을 할 때는<br>채택할 수 없습니다.
                </div>
            </div>

            <div @click="closeModal" class="select_btn">알겠습니다</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChooseClueModal',

    methods: {        
        closeModal: function() {
            this.$emit('close_choose_clue_modal')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.article_modal_container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    /* height: 620px; */
    background-color: #000000cc;
    top: 0px;
    left: 0px;
    z-index: 2;
}

/* pc */
@media screen and (min-width: 415px) {
    .article_modal {
        position: fixed;
        width: 580px;
        height: 360px;
        background-color: white;
        left: calc((1280px / 2) - (580px / 2));
        top: calc((620px / 2) - (360px / 2) - 20px);
        padding: 10px;
        border-radius: 5px;
        overflow: hidden;
    }
    .x_btn {
        height:30px;
        font-size:26px;
        padding:0px 3px;
        font-weight:700;
        text-align: right;
        cursor:pointer;
    }
    .select_btn {
        margin-top: 10px;
        margin-bottom: 0px;
        margin-left: 20px;
        margin-right: 20px;
        font-size: 26px;
        text-align:center;
        padding: 5px;
        border:2px solid black;
        box-shadow: 2px 2px 2px gray;
        cursor:pointer;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .article_modal {
        position: fixed;
        width: 350px;
        height: 371px;
        background-color: white;
        left: calc(50vw - (350px / 2));
        top: calc(50vh - (371px / 2) - 30px);
        /* top: calc((620px / 2) - (340px / 2) - 20px); */
        overflow: hidden;
    }

    .select_btn {
        margin-top: 32px;
        margin-bottom: 0px;
        /* margin-left: 20px;
        margin-right: 20px; */
        font-size: 26px;
        font-weight: 700;
        text-align:center;
        padding: 10px;
        /* border:2px solid black; */
        border-top: 1px solid black;
    }
}
</style>
